import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const containersApi = {
  getAll(params?: cyrian.api.containers.GetParams): ApiResponse<WrappedResult<cyrian.api.containers.Container[]>> {
    return request({
      method: 'get',
      url: '/containers',
      params,
    });
  },
  create(data: cyrian.api.containers.ContainerParams): ApiResponse<WrappedResult<cyrian.api.containers.Container>> {
    return request({
      method: 'post',
      url: '/containers',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.containers.ContainerParams,
  ): ApiResponse<WrappedResult<cyrian.api.containers.Container>> {
    return request({
      method: 'patch',
      url: `containers/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/containers/${id}`,
    });
  },
};

export default containersApi;
